module.exports = __webpack_public_path__ + "media/app/components/MainNav/KamereoSideNav.9c77aed7.svg";